import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';



export const market = {

	data() {
		return {
            markets: [],
            market_listener:[],
            singleMarket: {},
            subcomponents: [],
		}
    },
	methods: {
        clearMarketData(){
            console.log("clearMarketData")
            this.markets = [];
            this.singleMarket = {};
            this.subcomponents = []
            for(let l of this.market_listener){
                l();
            }
        },
        // generatesubComponents(market_id){
        //     console.log("generatesubComponents")
        //     alert("generate subcomponents at ", market_id)
        // },
        startMarketListener(){
            console.log("startMarketListener")
            let vm = this;
            let user = this.getUser();
            let listenr = firebase.firestore().collection("markets")
                .where("access", "array-contains", user.client)
                .onSnapshot(snapshot => {
                    vm.markets = [];
                    snapshot.forEach((m) => {
                        let mm = m.data()
                        mm['id'] = m.id
                        vm.markets.push(mm)
                    })
            })
            this.market_listener.push(listenr)
        },
        startSingleMarketListener(market_id){
            console.log("startSingleMarketListener");
            let vm = this;
            let listener = firebase.firestore().collection("markets").doc(market_id).onSnapshot(snapshot => {
                vm.singleMarket = snapshot.data();
            })
            this.market_listener.push(listener);
        },
        startComponentListener(market_id){
            console.log("startComponentListener");
            let vm = this;
            let user = this.getUser();
            let listener = firebase.firestore().collection("markets").doc(market_id).collection(user.client).onSnapshot(snapshot => {
                vm.subcomponents = [];
                snapshot.forEach((c) => {
                    let comp = c.data()
                    comp["component_id"] = c.id
                    vm.subcomponents.push(comp)
                })
            })
            this.market_listener.push(listener);
        }
    }
}